import { render, staticRenderFns } from "./PaymentOrderForm.vue?vue&type=template&id=52b2984c&scoped=true"
import script from "./PaymentOrderForm.vue?vue&type=script&lang=ts"
export * from "./PaymentOrderForm.vue?vue&type=script&lang=ts"
import style0 from "./PaymentOrderForm.vue?vue&type=style&index=0&id=52b2984c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b2984c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52b2984c')) {
      api.createRecord('52b2984c', component.options)
    } else {
      api.reload('52b2984c', component.options)
    }
    module.hot.accept("./PaymentOrderForm.vue?vue&type=template&id=52b2984c&scoped=true", function () {
      api.rerender('52b2984c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/PaymentOrderForm.vue"
export default component.exports